"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var utils_1 = require("./utils");
function reducer(state, action) {
    var _a;
    if (state === void 0) { state = constants_1.initialState; }
    switch (action.type) {
        case constants_1.GET_RESTRICTION_REQUEST: {
            var args = action.payload.args;
            if (!args) {
                return state;
            }
            var betslipOddIds = args.betslipOddIds;
            var betslipRestrictions = state.betslipRestrictions;
            var betslipRestrictionId = utils_1.getBetslipRestrictionId(betslipOddIds);
            if (betslipRestrictions.has(betslipRestrictionId))
                return state;
            var nextBetslipRestrictions = betslipRestrictions.set(betslipRestrictionId, []);
            return state.set('betslipRestrictions', nextBetslipRestrictions);
        }
        case constants_1.UPDATE_RESTRICTIONS:
        case constants_1.GET_RESTRICTION_SUCCESS: {
            var _b = action.payload, restrictions = _b.data.restrictions, betslipOddIds = _b.betslipOddIds;
            var betslipRestrictionId = utils_1.getBetslipRestrictionId(betslipOddIds);
            var stateRestrictions = state.betslipRestrictions;
            var maxBetRestriction = restrictions.find(utils_1.maxBetRestrictionCondition);
            if (!maxBetRestriction) {
                var prevMaxBetRestriction = (_a = stateRestrictions
                    .get(betslipRestrictionId)) === null || _a === void 0 ? void 0 : _a.find(utils_1.maxBetRestrictionCondition);
                if (prevMaxBetRestriction) {
                    restrictions.push(prevMaxBetRestriction);
                }
            }
            var nextBetslipRestriction = stateRestrictions.set(betslipRestrictionId, restrictions);
            return state.set('betslipRestrictions', nextBetslipRestriction);
        }
        case constants_1.GET_RESTRICTION_FAIL: {
            if (!action.payload.args)
                return state;
            var betslipOddIds = action.payload.args.betslipOddIds;
            var betslipRestrictions = state.betslipRestrictions;
            var betslipRestrictionId = utils_1.getBetslipRestrictionId(betslipOddIds);
            var nextBetslipRestrictions = betslipRestrictions.delete(betslipRestrictionId);
            return state.set('betslipRestrictions', nextBetslipRestrictions);
        }
        default: {
            return state;
        }
    }
}
exports.default = reducer;
//# sourceMappingURL=reducer.js.map